function formatAdaptivProductTitles(scope = document) {
  scope.querySelectorAll('[data-testid="product-information"] .product-details h1').forEach((title) => {
    if (title.dataset.adaptivTitleFormatted === 'true') return;

    const parts = title.textContent
      .trim()
      .split(/\s+-\s+/)
      .filter(Boolean);

    if (!parts.length) return;

    const model = document.createElement('span');
    title.classList.add('adaptiv-pdp-title');
    model.className = 'adaptiv-pdp-title__model';
    model.textContent = parts[0];
    title.replaceChildren(model);

    if (parts.length > 1) {
      const feel = document.createElement('span');
      feel.className = 'adaptiv-pdp-title__feel';
      feel.textContent = parts.slice(1).join(' ');
      title.append(feel);
    }

    title.dataset.adaptivTitleFormatted = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => formatAdaptivProductTitles(), { once: true });
} else {
  formatAdaptivProductTitles();
}

document.addEventListener('shopify:section:load', (event) => {
  formatAdaptivProductTitles(event.target);
});
